import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import i18n, { ensureLanguageResources, getInitialLanguageFromBrowser } from "./i18n";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = createRoot(document.getElementById("root") as HTMLElement);

if (process.env.REACT_APP_SENTRY_ENABLED === "true") {
  import("@sentry/browser").then((Sentry) => {
    Sentry.init({
      dsn: "https://75a9664ef8cdaccee02d9288b4b19bb7@o4509124024795136.ingest.de.sentry.io/4509124029251664",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.feedbackIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        "localhost",
        /^https:\/\/app.calibratetechnology.com/,
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  });
}

const bootstrap = async (): Promise<void> => {
  const initialLanguage = getInitialLanguageFromBrowser();

  await ensureLanguageResources(initialLanguage);

  if (i18n.language !== initialLanguage) {
    await i18n.changeLanguage(initialLanguage);
  }

  root.render(
    <AuthProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </AuthProvider>
  );
};

void bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
